package presentation.screens.allVideos

import kotlinx.serialization.Serializable
import models.VideoDetails
import utils.UiAction
import utils.UiState


data class AllVideosState(
    val title: String = "",
    val screenType: ScreenType,
    val isLoading: Boolean = true,
    val isNextLoading: Boolean = true,
    val isError: Boolean = false,
    val videos: List<VideoDetails>? = null,
): UiState {

    @Serializable
    enum class ScreenType {
        ReleaseSoon,
        NewMovies,
        NewTvShows,
        Cartoons,
        ByActor,
    }
}

sealed interface AllVideosMVIAction : UiAction {

    data object OnReload : AllVideosMVIAction
    data object FetchNextPage : AllVideosMVIAction
    data object BackPressed : AllVideosMVIAction
    data object SearchClicked : AllVideosMVIAction
    data class OpenDetails(val id: Int, val isTvShow: Boolean) : AllVideosMVIAction
}